import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "sonner";
import "@/App.css";
import { CartProvider } from "@/context/CartContext";
import { WishlistProvider } from "@/context/WishlistContext";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { CartDrawer } from "@/components/CartDrawer";
import Home from "@/pages/Home";
import Shop from "@/pages/Shop";
import Account from "@/pages/Account";
import Admin from "@/pages/Admin";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";

const ScrollManager = () => {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) {
      const t = setTimeout(() => window.__lenis?.scrollTo(hash, { offset: -80 }), 400);
      return () => clearTimeout(t);
    }
    window.__lenis?.scrollTo(0, { immediate: true });
  }, [pathname, hash]);
  return null;
};

const Chrome = ({ children }) => {
  const { pathname } = useLocation();
  const bare = pathname === "/admin";
  return (
    <>
      {!bare && <Header />}
      {children}
      {!bare && <Footer />}
    </>
  );
};

function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)) });
    window.__lenis = lenis;
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="grain bg-cream">
      <CartProvider>
        <WishlistProvider>
        <BrowserRouter>
          <ScrollManager />
          <Chrome>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/shop" element={<Shop />} />
              <Route path="/account" element={<Account />} />
              <Route path="/payment/success" element={<PaymentSuccess />} />
              <Route path="/payment/cancel" element={<PaymentCancel />} />
              <Route path="/admin" element={<Admin />} />
              <Route path="*" element={<Home />} />
            </Routes>
          </Chrome>
          <CartDrawer />
          <Toaster position="bottom-right" toastOptions={{ style: { background: "#0B192C", color: "#FAF9F6", border: "1px solid rgba(212,175,55,0.35)", borderRadius: 0 } }} />
        </BrowserRouter>
        </WishlistProvider>
      </CartProvider>
    </div>
  );
}

export default App;
